import React from 'react';
import { Modal, Radio, Space, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { resolveTrackDownloadRangeByPreset } from '../utils/dashboard/trackDownloadHelpers';

/**
 * 队员轨迹时间选择弹窗（获取轨迹 / 下载轨迹共用）
 * mode: 'fetch' | 'download'
 */
export default function TrackDownloadModal({
  modal,
  onChange,
  onCancel,
  onOk
}) {
  if (!modal) return null;

  const isFetch = modal.mode === 'fetch';
  const memberName = modal.member?.name || '';

  return (
    <Modal
      title={
        memberName
          ? `${isFetch ? '获取轨迹' : '下载轨迹'} - ${memberName}`
          : (isFetch ? '获取轨迹' : '下载轨迹')
      }
      open={modal.visible}
      onCancel={onCancel}
      onOk={onOk}
      okText={isFetch ? '开始获取' : '开始下载'}
      cancelText="取消"
      confirmLoading={modal.loading}
      destroyOnHidden
      width={460}
    >
      <div style={{ marginBottom: 12, color: '#666', fontSize: 13 }}>
        {isFetch
          ? <>请选择要获取的时间范围：最近天数，或自定义开始/结束时间。</>
          : <>默认下载<strong>当天</strong>全部轨迹，也可选择其他时间段。</>}
      </div>
      <Radio.Group
        value={modal.preset}
        onChange={(e) => {
          const preset = e.target.value;
          const range = resolveTrackDownloadRangeByPreset(preset, dayjs, modal.range);
          onChange?.({
            ...modal,
            preset,
            range
          });
        }}
      >
        <Space direction="vertical" size={8}>
          <Radio value="today">当天（00:00 ~ 今天结束）</Radio>
          <Radio value="last7">最近 7 天</Radio>
          <Radio value="last30">最近 30 天</Radio>
          <Radio value="all">全部历史</Radio>
          <Radio value="custom">自定义开始/结束时间</Radio>
        </Space>
      </Radio.Group>
      {modal.preset === 'custom' && (
        <div style={{ marginTop: 14 }}>
          <DatePicker.RangePicker
            showTime
            value={modal.range}
            onChange={(vals) => onChange?.({ ...modal, range: vals })}
            style={{ width: '100%' }}
            placeholder={['开始时间', '结束时间']}
          />
        </div>
      )}
    </Modal>
  );
}
